import { render, staticRenderFns } from "./editTitulo.vue?vue&type=template&id=66fbc482"
import script from "./editTitulo.vue?vue&type=script&lang=js"
export * from "./editTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports